import { FeaturesPage } from '@repo/ui/features/superadmin';

export default function SuperAdminFeaturesPage() {
  return (
    <div className="w-full py-6">
      <FeaturesPage />
    </div>
  );
}
